// frontend/src/services/api.js
import axios from 'axios';

// Determine the base URL based on the Node environment.
// process.env.NODE_ENV is automatically set by Create React App.
// Relative path in both dev and prod. In dev, src/setupProxy.js forwards /api
// to localhost:5000, so the app works through one origin (incl. tunnels).
const baseURL = '/api';

// Create the axios instance with the dynamic baseURL.
const api = axios.create({
    baseURL: baseURL
});

// Export imageBaseUrl for use in other files (for serving images)
export const imageBaseUrl = process.env.REACT_APP_API_URL || '';

// Request Interceptor: Add the JWT token to every outgoing request.
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response Interceptor: Handle global errors, specifically for expired sessions.
api.interceptors.response.use(
    // 1. On a successful response, just return it.
    (response) => response,

    // 2. On an error response, check for 401 Unauthorized.
    (error) => {
        // Handle connection errors (Backend Unreachable)
        if (!error.response) {
            // This happens when the request was made but no response was received
            // (e.g. Server is down, network issues, or CORS errors)
            window.dispatchEvent(new CustomEvent('backend-connection-error'));
        }

        // Check if the error response exists and the status is 401
        if (error.response && error.response.status === 401) {
            // This indicates an invalid or expired token.

            // Remove the bad token from storage.
            localStorage.removeItem('token');

            // Force a hard redirect to the login page to clear all application state.
            // Only redirect if we are not already on the login page to avoid loops.
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }

        // For all other errors (e.g., 404, 500), let the component's .catch() block handle them.
        return Promise.reject(error);
    }
);

export default api;